<template>
  <v-row
    align="center"
    justify="center"
    class="mt-8 glossary__choices mb-8 pa-2"
  >
    <v-col cols="12">
      <v-skeleton-loader
        type="text"
        loading
        class="search-result-heading-loader"
      />
      <v-skeleton-loader
        v-for="i in 3"
        :key="i"
        type="text"
        loading
        class="search-result-text-loader"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.glossary__choices {
  background-color: #fff;
  box-shadow: 0px 0.375rem 1.125rem rgba(0, 0, 0, 0.06);
  border-radius: 0.25rem;
  margin: -0.0625rem;
}
.search-result-heading-loader {
  margin-top: 40px;
  padding-bottom: 8px;
  width: 100px;
  &::v-deep .v-skeleton-loader__text {
    height: 22px;
  }
}
.search-result-text-loader {
  margin-top: 30px;
}
</style>
